module.exports = __webpack_public_path__ + "static/media/responsibility-social-impact-old.db3cb003.jpg";